import { Container } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { Match } from '@reach/router';
import PropTypes from 'prop-types';
import React from 'react';

import HeaderButtons from './header-buttons';
import HeaderLogo from './header-logo';
import HeaderMenu from './header-menu';
import MobileMenu from './mobile-menu';

const useWindowScrollPosition =
  typeof window !== `undefined`
    ? require('@rehooks/window-scroll-position')
    : () => {
        return { x: 0, y: 0 };
      };

const useStyles = makeStyles(theme => ({
  headerHome: {
    zIndex: 100,
    background: 'transparent'
  },
  header: {
    zIndex: 100,
    color: theme.colors.headerColor,
    backgroundColor: theme.colors.headerBackgroundColor,
    boxShadow: theme.shadows[1]
  },
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    color: 'inherit'
  },
  container: {
    [theme.breakpoints.up('lg')]: {
      paddingRight: 10,
      paddingLeft: 10
    }
  }
}));

const Header = ({ siteTitle, user, isAuthenticated = false }) => {
  const classes = useStyles();

  const [isScrolledDown, setIsScrolledDown] = React.useState(true);

  const options = {
    throttle: 300
  };
  const position = useWindowScrollPosition(options);

  React.useEffect(() => {
    setIsScrolledDown(position.y < 1);
  }, [position.y]);

  return (
    <Match path="/">
      {props => (
        <AppBar
          elevation={0}
          className={
            // eslint-disable-next-line react/prop-types
            isScrolledDown && Boolean(props.match)
              ? classes.headerHome
              : classes.header
          }
        >
          <Container maxWidth="xl" className={classes.container}>
            <Toolbar component="nav" className={classes.root} disableGutters>
              {/* Logo */}
              <HeaderLogo
                siteTitle={siteTitle}
                // eslint-disable-next-line react/prop-types
                isColor={isScrolledDown && Boolean(props.match)}
              />

              {/* Mobile Menu */}
              <Hidden lgUp>
                <MobileMenu
                  // user={user}
                  isAuthenticated={isAuthenticated}
                  // eslint-disable-next-line react/prop-types
                  isColor={isScrolledDown && Boolean(props.match)}
                />
              </Hidden>

              {/* Desktop Menu */}
              <Hidden mdDown>
                <HeaderMenu />
                <HeaderButtons
                  // user={user}
                  isAuthenticated={isAuthenticated}
                  // eslint-disable-next-line react/prop-types
                  isColor={isScrolledDown && Boolean(props.match)}
                />
              </Hidden>
            </Toolbar>
          </Container>
        </AppBar>
      )}
    </Match>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  user: PropTypes.shape({}),
  // eslint-disable-next-line react/require-default-props
  isAuthenticated: PropTypes.bool
};

export default Header;
